export const METAMASK_ACCOUNTS_KEY = 'add-wallet-form-multiple-wallets';
